<!-- Component des diffusion d'un écran -->

<!-- MARK: Diffusion Client -->
@if (type === 'Client') {
    <div class="newDiffusion" (click)="addNew(face.faceId)">
        <mat-icon>add</mat-icon>
        <span>Ajouter une diffusion</span>
    </div>

    @if (toClientFace(face).diffusions?.length > 0) {
        <mat-accordion #clientAccordion="matAccordion" multi class="diffusionAccordion">
            <mat-expansion-panel [expanded]="true" class="diffusionExpander">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{ toClientFace(face).diffusions.length }} Diffusion{{
                            toClientFace(face).diffusions.length === 1 ? '' : 's'
                        }}
                    </mat-panel-title>
                    <mat-panel-description>
                        ({{ getCurrentNbDiff(toClientFace(face).diffusions) }} en cours)
                    </mat-panel-description>
                </mat-expansion-panel-header>

                @for (diffusion of toClientFace(face).diffusions; track $index) {
                    <app-spot-card
                        (diffusionsDeleted)="deleteDiff($event)"
                        (diffForScreenDeleted)="diffForScreenDeleted.emit($event)"
                        [type]="type"
                        [face]="face"
                        [diffusion]="diffusion"
                    ></app-spot-card>
                }
            </mat-expansion-panel>
        </mat-accordion>
    }
}

<!-- MARK: Diffusion Wancom -->
@if (type === 'Wancom') {
    @if (userAuth$.hasRight('CanAddDiffusionOnPublicCampaign')) {
        <div id="addNewdDiffWncmBtn" class="newDiffusion Wncm" (click)="addDiffusionWancom(campaign, face.faceId)">
            <mat-icon>add</mat-icon>
            <span>Ajouter une diffusion</span>
        </div>
    }

    @if (campaign.diffusions?.length > 0) {
        <mat-accordion #wncmAccordion="matAccordion" multi class="diffusionAccordion">
            <mat-expansion-panel [expanded]="true" class="diffusionExpander wncmDiff">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{ campaign.diffusions?.length }} Diffusion{{ campaign.diffusions?.length === 1 ? '' : 's' }}
                    </mat-panel-title>
                    <mat-panel-description>
                        ({{ getCurrentNbDiff(campaign.diffusions) }} en cours)
                    </mat-panel-description>
                </mat-expansion-panel-header>

                @for (diffusion of campaign.diffusions; track $index; let first = $first) {
                    <hr class="campaignSeparation" />

                    @for (spot of diffusion.spots; track $index) {
                        <app-spot-card
                            (diffusionsDeleted)="deleteDiff($event)"
                            (diffForScreenDeleted)="diffForScreenDeleted.emit($event)"
                            [type]="type"
                            [face]="face"
                            [campaign]="campaign"
                            [diffusion]="diffusion"
                            [spot]="spot"
                            [isFirst]="first"
                        ></app-spot-card>
                    }
                }
            </mat-expansion-panel>
        </mat-accordion>
    }
}
